import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useAuth } from "../../../core/hooks/useAuth";
import { roleNames } from "../../../core/constants/userConstants";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { UserFill } from "../../../core/common/icons/icons";
import { useTranslation } from "react-i18next";

const ProfileCard = () => {
  const { moodleUser, isMoodleUserLoading } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="profile-card overflow-hidden bg-blue-gradient2 mb-4 p-5">
      <div className="profile-card-bg">
        <ImageWithBasePath
          src={"assets/img/bg/card-bg-01.png"}
          className="profile-card-bg-1"
          alt="Background"
        />
      </div>
      <div className="row align-items-center row-gap-3">
        <div className="col-lg-6">
          <div className="d-flex align-items-center">
            <span className="avatar avatar-xxl avatar-rounded me-3 border border-white border-2 position-relative">
              {moodleUser ? (
                <img src={moodleUser?.profileimageurl} alt="User Avatar" />
              ) : (
                <UserFill />
              )}
              <span className="verify-tick">
                <i className="isax isax-verify5" />
              </span>
            </span>
            <div>
              {isMoodleUserLoading ? (
                <SkeletonTheme baseColor="#DBDBDB" highlightColor="#ccc">
                  <p>
                    <Skeleton width={150} />
                    <Skeleton width={130} />
                  </p>
                </SkeletonTheme>
              ) : (
                <>
                  <h5 className="mb-1 text-white d-inline-flex align-items-center">
                    <Link to={all_routes.studentProfile}>
                      {moodleUser?.fullname}
                    </Link>
                  </h5>
                  <p className="text-light">
                    {t(roleNames[moodleUser?.role?.roleid])}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="d-flex align-items-center justify-content-lg-end flex-wrap gap-2">
            {/* Các nút khác */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
